import { getController } from '@/services/service'

const url = 'accounts'

export const accountService = {
	...getController<Api.Account, Api.AccountPostInput>(
		url
	),
}

export default accountService
